import ScrollWatcher from './util/scroll-watcher';

class App {
	constructor() {
		this.instances = {
			components: {
				imageGallerySlider: [],
				mediaContentSlider: []
			},
			blocks: {
			},
			scrollWatcher: null
		};

		this.init();
		this.initComponents();
		// this.initBlocks();
	}

	init() {

		this.scrollWatcher = new ScrollWatcher((params) => {
			ScrollWatcher.defaultCallback(params, 100);
		});

	}

	async initComponents() {




	}


	async initBlocks() {

	}

}

export default App;
